import { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigation = [
    { name: 'Services', path: '/services' },
    { name: 'Portfolio', path: '/portfolio' },
    { name: 'Our Team', path: '/our-team' },
    { name: 'Careers', path: '/careers' },
    { name: 'Blog', path: '/blog' },
    { name: 'Advertising', path: '/advertising' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <nav className="fixed w-full top-0 z-50 bg-white backdrop-blur-lg border-b border-gray-200 shadow-lg" role="navigation" aria-label="Main navigation">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <img
              src="/images/kommonview-logo.png"
              alt="Kommonview Logo"
              className="h-12 w-auto transition-transform duration-300 group-hover:scale-110"
              width="150"
              height="48"
            />
            <span className="text-primary font-bold text-xl tracking-tight hidden sm:block">KOMMONVIEW</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-1">
            {navigation.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="px-4 py-2 text-primary/80 hover:text-primary hover:bg-primary/5 rounded-lg transition-all duration-200 font-medium"
              >
                {item.name}
              </Link>
            ))}
            <a
              href="https://kommonview.atlassian.net/servicedesk/customer/portal/1"
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-2 text-primary/80 hover:text-primary hover:bg-primary/5 rounded-lg transition-all duration-200 font-medium"
            >
              Support
            </a>
            <Link
              to="/contact"
              className="ml-4 px-6 py-2.5 bg-primary hover:bg-primary-800 text-white rounded-lg font-semibold transition-all duration-200 shadow-lg hover:shadow-xl"
            >
              Get Started
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-primary p-2 rounded-lg hover:bg-primary/5 transition-colors"
            aria-label="Toggle menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="lg:hidden bg-white backdrop-blur-xl border-t border-gray-200">
          <div className="px-4 py-4 space-y-2">
            {navigation.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsMenuOpen(false)}
                className="block px-4 py-3 text-primary/80 hover:text-primary hover:bg-primary/5 rounded-lg transition-all duration-200 font-medium"
              >
                {item.name}
              </Link>
            ))}
            <a
              href="https://kommonview.atlassian.net/servicedesk/customer/portal/1"
              target="_blank"
              rel="noopener noreferrer"
              className="block px-4 py-3 text-primary/80 hover:text-primary hover:bg-primary/5 rounded-lg transition-all duration-200 font-medium"
            >
              Support
            </a>
            <Link
              to="/contact"
              onClick={() => setIsMenuOpen(false)}
              className="block px-4 py-3 bg-primary hover:bg-primary-800 text-white rounded-lg font-semibold text-center transition-all duration-200"
            >
              Get Started
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Header;
